/* eslint-disable-next-line padded-blocks */
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import ReactDOMServer from "react-dom/server";
import html2pdf from "html2pdf.js";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
import ModelReport from "../../../components/report/ModelReport";
//pages
import FiltersReceipts from "./FiltersReceipts";
import TableReceiptsReport from "./TableReceiptsReport";
//assets
import Excel from "../../../assets/excel";
import { formatCurrency } from "../../../utils/formatCurrency";
import { formatDate } from "../../../utils/formatDate";
import { useAppContext } from "../../../context/AppContext";
import usePermission from "../../../hooks/usePermission";

export default function Receipts() {
  const { nomenclatures } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);

  usePermission("128"); //Visualizar Relatorio de Recebimentos
  const [now, setNow] = useState();
  const [user, setUser] = useState();
  const [logo, setLogo] = useState();
  const [table, setTable] = useState([]);
  const [month, setMonth] = useState(false);
  const [owner, setOwner] = useState(false);
  const [filters, setFilters] = useState([]);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);


  const items = [
    {
      template: () => (
        <Link to={"/reports/receipts"} className="p-breadcrumb-link">
          Recebimentos
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const exportToExcel = (sheetName) => {
// console.log("table", table);
    let data;
    if (month) {
      data = Object.keys(table.data).reduce((acc, itemYear) => {
        const year = table.data[itemYear];
        const monthsData = Object.keys(year.months).map((itemMonth) => {
          const month = year.months[itemMonth];
          return {
            Ano: itemYear,
            Mês: itemMonth,
            "Valor Total": formatCurrency(month.total_value),
            "Valor Recebido": formatCurrency(month.total_payment_value),
          };
        });
        return [...acc, ...monthsData];
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);
    } else {
      data = Object.keys(table.data).map((index) => {
        const item = table.data[index];
        return {
          "N°": item.id,
          [nomenclature[0].value]: item.block,
          [nomenclature[1].value]: item.land,
          "N° Parcela": item.sequence_number,
          Cliente: item.client,
          Descrição: item.description,
          Vencimento: item.due_date ? formatDate(item.due_date) : "",
          Valor: item.value ? formatCurrency(item.value) : "",
          Situação: item.status === 0 ? "Em Aberto" : "Pago",
          "Data de Recebimento": item.payment_date
            ? formatDate(item.payment_date)
            : "",
          Desconto: item.discount ? formatCurrency(item.discount) : "",
          Juros: item.fine ? formatCurrency(item.fine) : "",
          Honorário: item.honorary ? formatCurrency(item.honorary) : "",
          "Valor Pago": item.payment_value
            ? formatCurrency(item.payment_value)
            : "",
          "Fundo de Reserva": item.reserve_fund_sale,
          Observação: item.obs,
        };
      });
    }

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    XLSX.writeFile(wb, `relatório_recebimentos.xlsx`);
  };

  const handleExportExcel = (sheetName = "Relatório de Recebimentos") => {
    const columns = [
      "Q/L",
      "N°",
      "N° Parcela",
      "Cliente",
      "Descrição",
      "Vencimento",
      "Valor",
      "Situação",
      "Data Recebto",
      "Desconto",
      "Juros",
      "Multa",
      "Honor",
      "Pago",
      "Fundo Reserva",
      "Obs",
    ];
    let data;
    if (month) {
      data = Object.keys(table.data).reduce((acc, itemYear) => {
        const year = table.data[itemYear];
        const monthsData = Object.keys(year.months).map((itemMonth) => {
          const monthObj = year.months[itemMonth];
          return {
            Ano: itemYear,
            Mês: itemMonth,
            "Valor Total": formatCurrency(monthObj.total_value),
            "Valor Recebido": formatCurrency(monthObj.total_payment_value),
          };
        });
        return [...acc, ...monthsData];
      }, []);
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, `relatório_recebimentos.xlsx`);
      return;
    } else {
      data = Object.keys(table.data).map((index) => {
        const item = table.data[index];
        return {
          "Q/L": `${item.block || ''}/${item.land || ''}`,
          "N°": item.id,
          "N° Parcela": item.sequence_number,
          "Cliente": item.client,
          "Descrição": item.description,
          "Vencimento": item.due_date ? formatDate(item.due_date) : "",
          "Valor": item.value ? formatCurrency(item.value) : "",
          "Situação": item.status === 0 ? "Em Aberto" : "Pago",
          "Data Recebto": item.payment_date ? formatDate(item.payment_date) : "",
          "Desconto": item.discount ? formatCurrency(item.discount) : "",
          "Juros": item.daily_interest_rate ? formatCurrency(item.daily_interest_rate) : "",
          "Multa": item.fine ? formatCurrency(item.fine) : "",
          "Honor": item.honorary ? formatCurrency(item.honorary) : "",
          "Pago": item.payment_value ? formatCurrency(item.payment_value) : "",
          "Fundo Reserva": item.reserve_fund_sale,
          "Obs": item.obs,
        };
      });
    }

    // Garante a ordem das colunas
    const dataOrdered = data.map(row => {
      const ordered = {};
      columns.forEach(col => {
        ordered[col] = row[col] || "";
      });
      return ordered;
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(dataOrdered, { header: columns });
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, `relatório_recebimentos.xlsx`);
  };

  const handlePrint = () => {
    const headerContent = (
      <div style={{ color: "#000000" }}>
        <div>
          <div className="header-contract-land pt-3 pb-2">
            <div className="row">
              <div className="col-md-3 d-flex justify-content-center">
                {logo && <img src={logo} alt="logo" width={100} />}
              </div>
              <div className="col-md-6 text-center pt-4">
                <h3 className="fw-bolder">RELATÓRIO DE RECEBIMENTOS</h3>
              </div>
              <div className="col-md-3 d-flex justify-content-end pt-4">
                <div className="mx-3 text-center">
                  <h6>{now}</h6>
                  <p style={{ fontSize: "9px" }}>Emitido por: {user}</p>
                </div>
              </div>
            </div>
            <div className="row text-center d-flex justify-content-center my-2">
              {filters.map((item, index) => (
                <div className="w-auto my-2 text-start d-flex" key={index}>
                  <h6 className="mx-3">
                    <span
                      className="fw-bolder text-gray"
                      style={{ fontSize: "13px" }}
                    >
                      {item.title}:{" "}
                    </span>{" "}
                    {item.content ? item.content.toString() : "N/A"}
                  </h6>
                  {index !== filters.length - 1 && (
                    <span className="mx-1" style={{ translate: "0px -2px" }}>
                      {" "}
                      |{" "}
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="table-content">
          <div className="my-1 text-center overflow-hidden">
            <TableReceiptsReport
              table={table && table}
              month={month}
              owner={owner}
            />
          </div>
        </div>
      </div>
    );

    const htmlString = ReactDOMServer.renderToString(headerContent);

    const options = {
      margin: 28,
      filename: "relatorio_recebimentos.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: {
        unit: "pt",
        format: "letter",
        orientation: "landscape",
        
      },
    };

    const addPageNumbers = (pdf) => {
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.setTextColor(100);
        pdf.text(
          `Página ${i} de ${totalPages}`,
          pdf.internal.pageSize.getWidth() - 100,
          pdf.internal.pageSize.getHeight() - 15
        );
      }
    };

    const generatePDF = () => {
      html2pdf()
        .from(htmlString)
        .set(options)
        .toPdf()
        .get("pdf")
        .then(function (pdfDoc) {
          addPageNumbers(pdfDoc);
          pdfDoc.save(options.filename);
        });
    };

    generatePDF();
  };
    const handleExportPDF = () => {
      const element = document.getElementById("sales-summary-report");
      if (!element) return;
  
      const options = {
        margin: 10,
        filename: "Relatório_Recebimentos.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2,  },
        jsPDF: { unit: "mm", format: "a3", orientation: "landscape" },
      };
  
      html2pdf()
        .from(element)
        .set(options)
        .save()
        .then(() => {
          element.classList.remove("force-light");
        })
        .catch(() => {
          element.classList.remove("force-light");
        });
    };

  return (
    <div className="row d-flex justify-content-between mb-3">
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <Panel title="Recebimentos">
        <FiltersReceipts
          setNow={setNow}
          loading={loading}
          setLogo={setLogo}
          setUser={setUser}
          setTable={setTable}
          setVisible={setVisible}
          setFilters={setFilters}
          setLoading={setLoading}
          setMonth={setMonth}
          setOwner={setOwner}
        />
      </Panel>

      {loading && (
        <Skeleton width="100%" height="600px" className="mt-4"></Skeleton>
      )}

      {visible && !loading && (
        <Panel mainCss="mt-4">
          <>
            {/* <hr className="my-4" /> */}
            <div className="px-2 pb-3">
              <div className="d-flex justify-content-end mb-4">
                <Button
                  icon="fa fa-file-excel"
                  className="p-button-success cursor-pointer"
                rounded
                  onClick={() => handleExportExcel("Relatório de Recebimentos")}
                  tooltip="Exportar para Excel"
                  tooltipOptions={{ position: "bottom" }}
              />
              {/* <Button
                icon="fa fa-file-excel"
                className="p-button-success cursor-pointer"
                rounded
                onClick={() => handlePrint()}
              /> */}
              <Button
                  icon="fa fa-file-pdf"
                  className="p-button-secondary cursor-pointer mx-2"
                  rounded
                  onClick={handleExportPDF}
                  tooltip="Exportar para PDF"
                  tooltipOptions={{ position: "bottom" }}
                />    
            
              </div>
              <div id="sales-summary-report" >
              <ModelReport
                date={now}
                madeBy={user}
                logo={logo}
                title="RELATÓRIO DE RECEBIMENTOS"
                filters={filters}
              >
                <div className="text-center overflow-hidden">
                  {table.length === 0 ? (
                    <div className="d-flex flex-column align-items-center mt-4">
                      <h4
                        className="p-3 fw-bolder"
                        style={{ translate: "0px -10px" }}
                      >
                        Nenhuma Informação Encontrada
                      </h4>
                    </div>
                  ) : (
                    <TableReceiptsReport
                      table={table}
                      month={month}
                      owner={owner}
                    />
                  )}
                </div>
              </ModelReport>
            </div>
            </div>
          </>
        </Panel>
      )}
    </div>
  );
}
